<template>
  <div>
    <b-list-group>
      <b-list-group-item
        v-for="s in suggestions"
        :key="s.id"
        button
        @click="applyPrompt(s.prompt)"
      >
        {{ s.prompt }}
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>

const maxItems = 5;
// Replace via prop when needed.
const dummyDashId = 999;

export default {
  data() {
    return {
      suggestionsUrl: `/dashboards/${dummyDashId}/panels/suggestions.json`,
      suggestions: [],
    };
  },
  methods: {
    applyPrompt(prompt) { this.$emit('click', prompt); },

    httpGet() {
      this.$http
        .get(this.suggestionsUrl)
        .then((response) => {
          this.suggestions = response.data;
          this.suggestions = this.suggestions.slice(0, maxItems);
        });
    },
  },
  mounted() {
    this.httpGet();
  },
};
</script>
